import styled from '@emotion/styled';

const ProfilePlayer = styled('div')({
  alignItems: 'center',
  display: 'flex',
  width: '100%',
});

export default ProfilePlayer;
